import { render, staticRenderFns } from "./UpdoxError.vue?vue&type=template&id=750ca1c2&scoped=true"
import script from "./UpdoxError.vue?vue&type=script&lang=js"
export * from "./UpdoxError.vue?vue&type=script&lang=js"
import style0 from "./UpdoxError.vue?vue&type=style&index=0&id=750ca1c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750ca1c2",
  null
  
)

export default component.exports